/* Geometry adapted from the preserved bnon-universe-3d-planets-bigger.html.
 * Each custom element owns its frame, observer and listeners. Shopify section
 * replacement triggers disconnect/connect, so editor reloads cannot leak loops.
 */
var bnonDesktopHomeEntrance = element => element.closest("#MainContent[data-template='index']")
  && window.matchMedia('(min-width: 1024px)').matches;
// Homepage sections used to begin at 72% opacity. Combined with an observer that
// could fire as soon as one pixel entered the viewport, that made their entrance
// look like the tail end of an animation. Keep this adjustment exclusive to the
// desktop homepage (the hero does not use these helpers), but wait until a
// meaningful portion is visible and always animate from a clear initial state.
var bnonEntranceThreshold = (element, fallback) => bnonDesktopHomeEntrance(element)
  ? Math.max(fallback, .15)
  : fallback;
var bnonEntranceDuration = (element, duration) => bnonDesktopHomeEntrance(element)
  ? Math.round(duration * 1.68)
  : duration;
var bnonEntranceEasing = (element, fallback) => bnonDesktopHomeEntrance(element)
  ? 'cubic-bezier(.22, .65, .25, 1)'
  : fallback;
// A small amount of initial visibility prevents a visible "off → on" flash
// when the observer starts an animation as the section reaches the viewport.
// It is still far enough from the finished state to make the motion readable.
var bnonEntranceStartOpacity = element => bnonDesktopHomeEntrance(element) ? .35 : 0;
